import React from "react";
import { Grid, Paper } from "@mui/material";
import { useSelector } from "react-redux";
import { BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar, PieChart, Pie, Label, Cell, Legend, Text, LabelList, ResponsiveContainer } from "recharts";
import { Box } from "@mui/system";
import { Card } from "antd";
export default function AnswerStatisticsGraph() {
    const myStatState = useSelector((state) => state.myStatsData);
    const RatedData = [];
    const getAllValues = Object.values(myStatState.ratingsByGroup);
    const sum = getAllValues.reduce((a, b) => {
        return a + b;
    }, 0);
    const newArray = myStatState.domainByExpert.map((data) => {
        return { name: data.domainName, value: data.answerCount, fill: "rgb(124, 181, 236)" }
    })
    const nonRated = Object.entries(myStatState.ratingsByGroup).map(([name, value]) => ({ name, value }));
    const obj1 = { name: 'Rated', value: sum }
    const obj2 = { name: 'Non-Rated', value: (nonRated.length !== 0 && nonRated[0].value) }
    RatedData.push(obj1);
    RatedData.push(obj2);
    const ratingStarsData = Object.entries(myStatState.ratingsByGroup).map(([name, value]) => ({ name: name + " " + "star", value: value }))
    ratingStarsData.splice(0, 1);
    const ratingStarsColors = ['rgb(220,132,6)', 'rgb(255,150,0)', 'rgb(255,173,0)', 'rgb(255,197,0)', 'rgb(255,220,0)'];
    const GET_COLORS = ['#7cb5ec', '#434348', '#90ed7d', '#f7a35c', '#8085e9', '#f15c80', '#e4d354', '#2b908f', '#f45b5b', '#91e8e1']
    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip">
                    <div>
                        {payload.map((pld) => (
                            <div style={{ display: "inline-block", padding: 7, backgroundColor: "#f3f3f3", color: "black", fontSize: "12px" }}>
                                <div style={{ color: pld.fill }}>{pld.name}:{" "}<b>{pld.value.toLocaleString()}</b></div>
                            </div>
                        ))}
                    </div>
                </div>
            );
        }

        return null;
    };

    const headingColor = {
		color:'rgb(42, 54, 74)'
	}
    return (
        <>
 <Grid item xs={12} sm={12} lg={6} xl={6}>
    <Card title="Domains" style={{ textAlign: "center" }} styles={{header:headingColor}}>
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
            <ResponsiveContainer width="100%" height={400}>
                <PieChart>
                    <Pie
                        dataKey="value"
                        isAnimationActive={false}
                        data={newArray}
                        cx="50%"
                        cy="50%"
                        outerRadius="50%"
                        fill="rgb(124, 181, 236)"
                        label
                        cursor="default"
                        minAngle={5}

                    >
                        {GET_COLORS.map((entry, index) => (
                            <Cell
                                style={{ outline: "none" }}
                                key={`cell-${index}`}
                                fill={GET_COLORS[index % GET_COLORS.length]}
                            />
                        ))}
                    </Pie>
                    <Tooltip content={<CustomTooltip />} itemStyle={{ fontFamily: "inherit", fontSize: "12px" }} />
                    <Legend
                        wrapperStyle={{
                            bottom: "20px",
                            whiteSpace: "break-spaces",
                            maxWidth: "90%",
                        }}
                        formatter={(value) => <span style={{ fontSize: "12px" }}>{value}</span>}
                        iconSize={10}
                        iconType="circle"
                        verticalAlign="bottom"
                    />
                </PieChart>
            </ResponsiveContainer>
        </Box>
    </Card>
</Grid>
<Grid item xs={12} sm={12} lg={6} xl={6}>
    <Card title="Ratings of Expert Answers" style={{ textAlign: "center" }} styles={{header:headingColor}}>
        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: "center", justifyContent: "center", width: "100%" }}>
            {/* Bar Chart */}
            <Box sx={{ width: { xs: "100%", md: "50%",lg:'60%',xl:'50%' }, display: "flex", justifyContent: "center" }}>
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart 
                        data={RatedData} 
                        margin={{ top: 10, right: 20, left: 20, bottom: 10 }} 
                        barGap={30} 
                        barCategoryGap={20}
                    >
                        <XAxis dataKey="name" style={{ fontSize: "14px" }} />
                        <YAxis style={{ fontSize: "14px" }} />
                        <Tooltip itemStyle={{ fontFamily: "inherit", fontSize: "12px" }} />
                        <Bar 
                            dataKey="value" 
                            fill="rgb(255, 220, 0)" 
                            // label={{ position: "top", fontWeight: "bold", fontSize: "14px", fontFamily: "inherit" }}
                            barSize={30} 
                        />
                    </BarChart>
                </ResponsiveContainer>
            </Box>

            {/* Pie Chart */}
            <Box sx={{ width: { xs: "100%", md: "60%",lg:'50%',xl:'50%' }, display: "flex", justifyContent: "center" }}>
                <ResponsiveContainer width="100%" height={400}>
                    <PieChart>
                        <Pie
                            dataKey="value"
                            isAnimationActive={false}
                            data={ratingStarsData}
                            outerRadius="70%"
                            fill="rgb(124, 181, 236)"
                            animationEasing="ease-in"
                            cursor="default"
                            paddingAngle={1.7}
                            label
                            cx="50%"
                            cy="50%"
                            minAngle={5}
                        >
                            {ratingStarsData.map((entry, index) => (
                                <Cell style={{outline:'none'}} key={`cell-${index}`} fill={ratingStarsColors[index % ratingStarsColors.length]} />
                            ))}
                        </Pie>
                        <Tooltip content={<CustomTooltip />} itemStyle={{ fontFamily: "inherit", fontSize: "12px" }} />
                        <Legend 
                            layout="horizontal" 
                            align="center" 
                            verticalAlign="bottom" 
                            wrapperStyle={{ maxWidth: "100%", overflow: "hidden", whiteSpace: "normal" }} 
                            iconSize={8} 
                            iconType="circle"
                        />
                    </PieChart>
                </ResponsiveContainer>
            </Box>
        </Box>
    </Card>
</Grid>



        </>)
}